export const getSlugWithDash = (slug?: string): string => {
  const slugWithoutRoot = slug?.replace('naturaily-root/', '');

  if (slugWithoutRoot?.startsWith('/')) {
    return slugWithoutRoot;
  }

  return `/${slugWithoutRoot}`;
};
